'use client';

import { toast, Toaster } from 'sonner';
import { useTheme } from '@mui/material/styles';

export function ThemedToaster(props: any): JSX.Element {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  
  return (
    <Toaster
      theme={isDark ? 'dark' : 'light'}
      {...props}
    />
  );
}

export { Toaster, toast };
